// Generado por la división del monolito.
// lote-93: nueva política de contraseña — mínimo 10 chars, letras+dígitos+
// símbolo, sin secuencias/comunes. La validación viva la hace PasswordSet.
// El campo persistido en disk sigue siendo `pinHash` para back-compat.
import { useState, useEffect, useRef, hashPin } from './common.jsx';
import { PasswordSet } from './password-set.jsx';

export function ResetPinPage({token}) {
  const [state, setState] = useState('loading'); // loading | form | success | error
  const [userName, setUserName] = useState('');
  const [msg, setMsg]   = useState('');

  useEffect(()=>{
    fetch('/api/reset-pin?token='+token).then(r=>r.json()).then(d=>{
      if (d.error) { setMsg(d.error); setState('error'); }
      else { setUserName(d.name); setState('form'); }
    }).catch(()=>{ setMsg('Error de conexión'); setState('error'); });
  },[token]);

  const handleSave = async ({ newPin }) => {
    // Mandamos `pin` en claro (no hash). El server lo valida contra la
    // política y lo hashea con scrypt.
    const r = await fetch('/api/reset-pin',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({token, pin: newPin})});
    const d = await r.json();
    if (!d.ok) {
      const codeMap = {
        too_short:'mínimo 10 caracteres', no_letter:'falta letra',
        no_digit:'falta dígito', no_symbol:'falta símbolo',
        common:'es una contraseña común', sequential:'es secuencia obvia',
        all_same:'todos los caracteres iguales'
      };
      const detail = Array.isArray(d.errors) ? d.errors.map(c => codeMap[c] || c).join(', ') : '';
      throw new Error((d.error || 'Error al guardar') + (detail ? ': ' + detail : ''));
    }
    setState('success');
  };

  const goLogin = () => { window.history.replaceState({},'','/'); window.location.reload(); };

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--sb)'}}>
      <div style={{background:'#fff',borderRadius:16,padding:32,maxWidth:460,width:'92%',boxShadow:'0 16px 32px rgba(0,0,0,.2)'}}>
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{background:'var(--pu)',width:52,height:52,borderRadius:14,display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:14}}>
            <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{width:24,height:24}}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          </div>
          <h2 style={{margin:0,fontSize:20,fontWeight:600,color:'var(--tx)'}}>Restablecer contraseña</h2>
        </div>

        {state==='loading' && <p style={{textAlign:'center',color:'#888'}}>Verificando enlace…</p>}

        {state==='error' && <>
          <p style={{textAlign:'center',color:'var(--rd)',fontWeight:600}}>{msg}</p>
          <button onClick={goLogin} style={{width:'100%',padding:'12px',background:'var(--pu)',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:'pointer',marginTop:16}}>
            Ir al inicio de sesión
          </button>
        </>}

        {state==='form' && <>
          <p style={{color:'#666',fontSize:14,textAlign:'center',marginBottom:20}}>Hola <strong>{userName}</strong>, crea tu nueva contraseña.</p>
          <PasswordSet onSave={handleSave} submitLabel="Guardar nueva contraseña"/>
        </>}

        {state==='success' && <>
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:48,marginBottom:12}}>✅</div>
            <h3 style={{margin:'0 0 8px',color:'var(--tx)'}}>Contraseña actualizada</h3>
            <p style={{color:'var(--tx2)',fontSize:14}}>Ya puedes iniciar sesión con tu nueva contraseña.</p>
          </div>
          <button onClick={goLogin} style={{width:'100%',padding:'13px',background:'var(--pu)',color:'#fff',border:'none',borderRadius:8,fontWeight:600,fontSize:14,cursor:'pointer',marginTop:20}}>
            Ir al inicio de sesión →
          </button>
        </>}
      </div>
    </div>
  );
}

export function LoginPage({onLogin}) {
  // Flujo: email → contraseña. No mostramos la lista de usuarios para no
  // filtrar quién está dado de alta.
  const [step, setStep] = useState('email'); // 'email' → 'pin'
  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotState, setForgotState] = useState('idle');
  const [forgotMsg, setForgotMsg] = useState('');
  const emailRef = useRef(null);
  const pinRef = useRef(null);

  const requestForgotPin = async () => {
    const e = (forgotEmail || email).trim().toLowerCase();
    if (!e || !e.includes('@')) { setForgotMsg('Introduce un email válido'); setForgotState('error'); return; }
    setForgotState('sending'); setForgotMsg('');
    try {
      const r = await fetch('/api/auth/forgot-pin',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:e})});
      if (r.ok) {
        setForgotState('sent');
        setForgotMsg('Si ese email existe en la app, recibirás un correo en breve con un enlace para restablecer tu contraseña. Caduca en 2 horas.');
      } else {
        const d = await r.json().catch(()=>({}));
        setForgotState('error');
        setForgotMsg(d.error || 'No se pudo enviar el correo. Avisa al manager.');
      }
    } catch { setForgotState('error'); setForgotMsg('Error de conexión.'); }
  };
  const openForgot = () => { setForgotEmail(email); setForgotState('idle'); setForgotMsg(''); setForgotOpen(true); };
  const closeForgot = () => setForgotOpen(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const gSession = params.get('google_session');
    const gError   = params.get('google_error');
    const gEmail   = params.get('ge');
    if (gSession) {
      setGoogleLoading(true);
      window.history.replaceState({}, '', '/');
      fetch(`/api/auth/google-session?token=${gSession}`)
        .then(r => r.json())
        .then(u => { if (u.id) onLogin(u); else setError('No se encontró un usuario con este email de Google.'); })
        .catch(() => setError('Error al verificar sesión de Google.'))
        .finally(() => setGoogleLoading(false));
    } else if (gError) {
      window.history.replaceState({}, '', '/');
      if (gError === 'user_not_found') setError(`No hay ningún usuario en la app con el email ${gEmail||'de tu cuenta Google'}. Pide al manager que lo añada.`);
      else if (gError === 'access_denied') setError('Acceso denegado en Google.');
      else setError('Error al iniciar sesión con Google. Inténtalo de nuevo.');
    } else {
      setTimeout(() => emailRef.current?.focus(), 100);
    }
  }, []);

  const continueToPin = async () => {
    const e = email.trim().toLowerCase();
    if (!e || !e.includes('@')) { setError('Introduce un email válido'); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch('/api/auth/check-email', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({email: e}) });
      const d = await r.json();
      if (!d.exists) {
        setError('Email no encontrado en la app. Pide al manager que te añada.');
      } else {
        setStep('pin');
        setTimeout(() => pinRef.current?.focus(), 50);
      }
    } catch { setError('Error de conexión.'); }
    setLoading(false);
  };

  const login = async () => {
    if (pin.length < 4) return; // permitimos 4+ chars para back-compat con PINs antiguos
    setLoading(true); setError('');
    try {
      // lote-92: enviamos el PIN en claro. El server lo hashea con scrypt y
      // setea la cookie HttpOnly de sesión automáticamente. Si el user aún
      // tenía pinHash legacy SHA-256 almacenado, el server lo verifica y
      // rehashea con scrypt en este mismo login.
      const r = await fetch('/api/auth/login', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email: email.trim().toLowerCase(), pin }) });
      if (r.ok) { const u = await r.json(); onLogin(u); }
      else {
        const data = await r.json().catch(() => ({}));
        setError(data.error || 'Contraseña incorrecta. Inténtalo de nuevo.');
        setPin(''); pinRef.current?.focus();
      }
    } catch { setError('Error de conexión.'); }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'var(--sb)',display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div style={{width:'100%',maxWidth:420}}>
        <div style={{textAlign:'center',marginBottom:36}}>
          <div style={{width:52,height:52,background:'var(--pu)',borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,fontWeight:600,color:'#fff',margin:'0 auto 14px'}}>U</div>
          <div style={{fontSize:20,fontWeight:600,color:'#fff',letterSpacing:'-.5px'}}>Ucademy Comisiones</div>
          <div style={{fontSize:13,color:'rgba(255,255,255,.4)',marginTop:4}}>Inicia sesión con Google o con tu email + contraseña</div>
        </div>

        <div style={{background:'var(--sb-h)',borderRadius:16,padding:24,boxShadow:'0 20px 60px rgba(0,0,0,.4)'}}>
          {googleLoading
            ? <div style={{textAlign:'center',padding:'14px 0',color:'rgba(255,255,255,.5)',fontSize:13}}>Verificando cuenta Google…</div>
            : <a href="/auth/google" style={{display:'flex',alignItems:'center',justifyContent:'center',gap:10,
                padding:'12px 16px',borderRadius:10,background:'#fff',color:'#3c4043',fontWeight:600,fontSize:14,
                textDecoration:'none',marginBottom:20,transition:'box-shadow .15s',boxShadow:'0 1px 3px rgba(0,0,0,.3)'}}
                onMouseEnter={e=>e.currentTarget.style.boxShadow='0 3px 12px rgba(0,0,0,.4)'}
                onMouseLeave={e=>e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,.3)'}>
                <svg viewBox="0 0 48 48" style={{width:20,height:20,flexShrink:0}}>
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                </svg>
                Entrar con Google
              </a>
          }
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:18}}>
            <div style={{flex:1,height:1,background:'rgba(255,255,255,.1)'}}/>
            <span style={{fontSize:11,color:'rgba(255,255,255,.25)',fontWeight:600,letterSpacing:'.5px'}}>O CON CONTRASEÑA</span>
            <div style={{flex:1,height:1,background:'rgba(255,255,255,.1)'}}/>
          </div>

          {error && <div style={{color:'var(--rd)',fontSize:12,marginBottom:14,textAlign:'center',background:'rgba(255,60,60,.1)',borderRadius:8,padding:'8px 12px'}}>{error}</div>}

          {step === 'email' ? (
            <>
              <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'1px',color:'rgba(255,255,255,.3)',marginBottom:8}}>Email</div>
              <input ref={emailRef} type="email" autoComplete="email" value={email}
                onChange={e=>{setEmail(e.target.value); setError('');}}
                onKeyDown={e=>e.key==='Enter' && continueToPin()}
                placeholder="tu@ucademy.com"
                style={{width:'100%',background:'rgba(255,255,255,.06)',border:`1.5px solid ${error?'var(--rd)':'rgba(255,255,255,.12)'}`,borderRadius:10,padding:'14px 16px',fontSize:15,color:'#fff',fontFamily:'inherit',outline:'none',marginBottom:14}}
              />
              <button onClick={continueToPin} disabled={loading || !email.trim()}
                style={{width:'100%',padding:'13px',background:'var(--pu)',border:'none',borderRadius:10,fontSize:14,fontWeight:600,color:'#fff',cursor:'pointer',opacity:(loading||!email.trim())?.55:1,transition:'opacity .15s'}}>
                {loading ? 'Comprobando…' : 'Continuar →'}
              </button>
            </>
          ) : (
            <>
              <button onClick={()=>{setStep('email'); setPin(''); setError(''); setTimeout(()=>emailRef.current?.focus(), 50);}}
                style={{background:'none',border:'none',cursor:'pointer',display:'flex',alignItems:'center',gap:6,color:'rgba(255,255,255,.4)',fontSize:12,marginBottom:16,padding:0}}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width:14,height:14}}><polyline points="15 18 9 12 15 6"/></svg> Cambiar email
              </button>
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:20,padding:'10px 14px',background:'rgba(255,255,255,.05)',borderRadius:10}}>
                <div className="uav com" style={{width:32,height:32,fontSize:14}}>{(email[0]||'?').toUpperCase()}</div>
                <div style={{fontSize:13,fontWeight:500,color:'#fff',wordBreak:'break-all'}}>{email}</div>
              </div>
              <div style={{marginBottom:16}}>
                <div style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'1px',color:'rgba(255,255,255,.3)',marginBottom:8}}>Contraseña</div>
                <input ref={pinRef} type="password" autoComplete="current-password" maxLength={64} value={pin}
                  onChange={e=>{ setPin(e.target.value); setError(''); }}
                  onKeyDown={e=>e.key==='Enter'&&login()}
                  placeholder="••••••••"
                  style={{width:'100%',background:'rgba(255,255,255,.06)',border:`1.5px solid ${error?'var(--rd)':'rgba(255,255,255,.12)'}`,borderRadius:10,padding:'14px 16px',fontSize:15,color:'#fff',fontFamily:'inherit',outline:'none'}}
                />
              </div>
              <button onClick={login} disabled={loading||pin.length<4}
                style={{width:'100%',padding:'13px',background:'var(--pu)',border:'none',borderRadius:10,fontSize:14,fontWeight:600,color:'#fff',cursor:'pointer',opacity:(loading||pin.length<4)?.55:1,transition:'opacity .15s'}}>
                {loading ? 'Comprobando…' : 'Entrar →'}
              </button>
              <div style={{textAlign:'center',marginTop:14}}>
                <button onClick={openForgot} style={{background:'none',border:'none',cursor:'pointer',color:'rgba(255,255,255,.55)',fontSize:12,textDecoration:'underline',padding:'4px 8px'}}>
                  ¿Olvidaste tu contraseña?
                </button>
              </div>
            </>
          )}
        </div>
        <div style={{textAlign:'center',marginTop:16,fontSize:11,color:'rgba(255,255,255,.15)'}}>Ucademy · Comisiones v2.0</div>
      </div>

      {forgotOpen && (
        <div onClick={closeForgot} style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:200,padding:20}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:14,padding:28,maxWidth:380,width:'100%',boxShadow:'0 12px 32px rgba(0,0,0,.3)'}}>
            <div style={{textAlign:'center',marginBottom:18}}>
              <div style={{background:'var(--pu)',width:44,height:44,borderRadius:12,display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:10}}>
                <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{width:20,height:20}}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              </div>
              <h3 style={{margin:0,fontSize:18,fontWeight:600,color:'var(--tx)'}}>Recuperar contraseña</h3>
            </div>
            {forgotState !== 'sent' && (<>
              <p style={{color:'var(--tx2)',fontSize:13,textAlign:'center',marginBottom:18,lineHeight:1.5}}>
                Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.
              </p>
              <input type="email" value={forgotEmail} onChange={e=>{setForgotEmail(e.target.value); if(forgotMsg)setForgotMsg('');}}
                placeholder="tu@ucademy.com" autoFocus
                onKeyDown={e=>e.key==='Enter'&&requestForgotPin()}
                style={{width:'100%',padding:'12px 14px',border:'1.5px solid var(--bd)',borderRadius:8,fontSize:14,boxSizing:'border-box',marginBottom:12,fontFamily:'inherit'}}/>
              {forgotMsg && <div style={{color:forgotState==='error'?'var(--rd)':'var(--tx2)',fontSize:12,marginBottom:12,textAlign:'center'}}>{forgotMsg}</div>}
              <div style={{display:'flex',gap:8}}>
                <button onClick={closeForgot} style={{flex:1,padding:'11px',background:'var(--bg)',color:'var(--tx)',border:'1px solid var(--bd)',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer'}}>Cancelar</button>
                <button onClick={requestForgotPin} disabled={forgotState==='sending'||!forgotEmail.trim()}
                  style={{flex:1,padding:'11px',background:'var(--pu)',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer',opacity:(forgotState==='sending'||!forgotEmail.trim())?.55:1}}>
                  {forgotState==='sending'?'Enviando…':'Enviar enlace'}
                </button>
              </div>
            </>)}
            {forgotState === 'sent' && (<>
              <div style={{textAlign:'center'}}>
                <div style={{fontSize:42,marginBottom:8}}>✉️</div>
                <p style={{color:'var(--tx2)',fontSize:13,lineHeight:1.5,marginBottom:18}}>{forgotMsg}</p>
                <button onClick={closeForgot} style={{padding:'11px 24px',background:'var(--pu)',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer'}}>Cerrar</button>
              </div>
            </>)}
          </div>
        </div>
      )}
    </div>
  );
}
